import { Component, OnInit } from '@angular/core';
import { ChartConfiguration, ChartOptions, ChartType } from 'chart.js';
import { StatisticsService } from '../../statistics/statistics.service';
import { UntypedFormControl } from '@angular/forms';
import { MonthModel } from '../../../shared/components/table/month.model';
import { months, monthsNumeric } from '../../../consts';
import { ActualSelected } from '../../../shared/utils';
import { StatisticsInvoicesModel } from '../../statistics/statistics.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { chartPalette, gradientFill, tooltipBase, horizontalBarScalesBase, barGeometry } from '../../resume/charts/chart-theme';

@Component({
    selector: 'convfact-invoices-statistics',
    templateUrl: './invoices-statistics.component.html',
    styleUrls: ['./invoices-statistics.component.css'],
    standalone: false
})

export class InvoiceStatisticsComponent implements OnInit {

  public statisticsInvoices: StatisticsInvoicesModel;

  public monthControl = new UntypedFormControl();
  public monthsSelected: string[];
  public monthList: MonthModel[] = [];
  public allMonthsSelected = false;

  public requestReady: boolean = false;

  public chartType: ChartType = 'bar';

  // ----- Clientes a los que mas vendo -----

  public chartDataCustomersISellToTheMost: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{
      data: [],
      label: 'Total vendido',
      backgroundColor: gradientFill(chartPalette.income),
      hoverBackgroundColor: chartPalette.income,
      ...barGeometry
    }]
  };

  public chartOptionsCustomersISellToTheMost: ChartOptions<'bar'> = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 700, easing: 'easeOutQuart' },
    scales: horizontalBarScalesBase(),
    plugins: { legend: { display: false }, tooltip: tooltipBase() }
  };

  // ----- Clientes que mas deben -----

  public chartDataCustomersWhoOwe: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{
      data: [],
      label: 'Total pendiente',
      backgroundColor: gradientFill(chartPalette.warning),
      hoverBackgroundColor: chartPalette.warning,
      ...barGeometry
    }]
  };

  public chartOptionsCustomersWhoOwe: ChartOptions<'bar'> = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 700, easing: 'easeOutQuart' },
    scales: horizontalBarScalesBase(),
    plugins: { legend: { display: false }, tooltip: tooltipBase() }
  };

  constructor(public statisticsService: StatisticsService, public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.setMonths();

    this.loadStatistics();
  }

  public loadStatistics(): void {
    this.requestReady = false;

    this.statisticsService.listStatisticsInvoices()
      .then((response: StatisticsInvoicesModel) => {
        this.requestReady = true;
        this.statisticsInvoices = response;
        this.fillInCharts();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error inesperado al cargar las estadisticas de los gastos");
      });
  }

  public fillInCharts() {
    // Clientes que mas vendo
    this.chartDataCustomersISellToTheMost = {
      labels: this.statisticsInvoices.customersISellToTheMostViewModel.map(x => x.clientName),
      datasets: [{
        data: this.statisticsInvoices.customersISellToTheMostViewModel.map(x => x.totalSold),
        label: 'Total vendido',
        backgroundColor: gradientFill(chartPalette.income),
        hoverBackgroundColor: chartPalette.income,
        ...barGeometry
      }]
    };

    // Clientes que mas deben
    this.chartDataCustomersWhoOwe = {
      labels: this.statisticsInvoices.customersWhoOweViewModel.map(x => x.clientName),
      datasets: [{
        data: this.statisticsInvoices.customersWhoOweViewModel.map(x => x.total),
        label: 'Total pendiente',
        backgroundColor: gradientFill(chartPalette.warning),
        hoverBackgroundColor: chartPalette.warning,
        ...barGeometry
      }]
    };
  }

  public setMonths() {
    if (this.monthList.length === 0) {
      let i = 1;
      months.forEach(element => {
        const newMonth = new MonthModel();
        newMonth.name = element;
        newMonth.selected = true;
        newMonth.number = i.toString();
        this.monthList.push(newMonth);
        i += 1;
      });
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
      ActualSelected.monthSelectedStatistics = monthsNumeric;
    }
  }

  public onChangeMonth(event) {
    this.monthsSelected = event.value;
    ActualSelected.monthSelectedStatistics = event.value;
    this.allMonthsSelected = false;

    this.monthList.forEach(element => element.selected = false);
    event.value.forEach(element => {
      this.monthList.find(f => f.number == element).selected = true;
    });

    this.loadStatistics();
  }

  public onSelectAll(event) {
    if (event.checked) {
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
      ActualSelected.monthSelectedStatistics = monthsNumeric;
      this.monthList.forEach(element => element.selected = true);
    } else {
      this.allMonthsSelected = false;
      this.monthsSelected = [];
      ActualSelected.monthSelectedStatistics = [];
      this.monthList.forEach(element => element.selected = false);
    }

    this.loadStatistics();
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public trackByIndex(i: number) { return i; }

}
